import React from "react";
import { createClasses } from "@bloomberg/media-ui-core";
import styles from "./style.module.css";
import { getDisclaimerNode } from "./disclaimers";

type SectionFrontDisclaimerProps = {
  sectionFrontName: string;
  selectedTab: string;
  variant: "top" | "bottom";
};

export default function SectionFrontDisclaimer(
  props: SectionFrontDisclaimerProps
) {
  const { sectionFrontName, selectedTab, variant } = props;

  const disclaimer = getDisclaimerNode(sectionFrontName, selectedTab, variant);

  if (!disclaimer) {
    return null;
  }

  const cx = createClasses({
    [styles.bottomDisclaimer]: variant === "bottom",
    [styles.topDisclaimer]: variant === "top",
  });

  return (
    <div className={styles.sectionNote}>
      <div className={cx}>{disclaimer}</div>
    </div>
  );
}
